<template>
	<div class="col-12 col-tab-1">
		<div class="row justify-content-center">
			<div class="col-12">
				<h5 class="mb-0 tab-title">Cambiate a SkyCel</h5>

				<p class="mb-2 text-center f-w-600">
					Envíanos tus datos y te daremos seguimiento en menos de 1 hr. para hacer el cambio de portabilidad.
				</p>
			</div>

			<b-form class="row justify-content-center" @submit="onSubmit">
				<b-form-group class="col-md-6 col-lg-5 custom-f-group" label="* Número (10 dígitos):">
					<b-form-input v-model="form.telefono" type="text" required placeholder="" :minlength="10"
						:maxlength="10" @keypress="$root.isNumber($event)" @paste="$root.noPaste"></b-form-input>
				</b-form-group>

				<b-form-group class="col-md-6 col-lg-5 custom-f-group" label="* Nombre (s):">
					<b-form-input v-model="form.nombres" type="text" required placeholder="" :minlength="5"
						:maxlength="100"></b-form-input>
				</b-form-group>

				<b-form-group class="col-md-6 col-lg-5 custom-f-group" label="* Apellido Paterno:">
					<b-form-input v-model="form.apellido_paterno" type="text" required placeholder="" :maxlength="60">
					</b-form-input>
				</b-form-group>

				<b-form-group class="col-md-6 col-lg-5 custom-f-group" label="* Apellido Materno:">
					<b-form-input v-model="form.apellido_materno" type="text" required placeholder="" :minlength="1"
						:maxlength="60"></b-form-input>
				</b-form-group>

				<b-form-group class="col-md-6 col-lg-5 custom-f-group" label="* CURP (18 dígitos):">
					<b-form-input v-model="form.curp" type="text" required placeholder="" :minlength="18"
						:maxlength="18"></b-form-input>

					<a class="d-inline-block mt-1" target="_blank" href="https://www.gob.mx/curp/">¿No conoces tu
						CURP?</a>
				</b-form-group>


				<div class="col-md-6 col-lg-5"></div>

				<div class="col-md-12 text-center mb-4">
					<p class="f-w-600" style="font-size: 1.10rem;">
						Los campos con * son obligatorios.
					</p>
				</div>

				<div class="col-10 text-center">
					<b-button type="submit" class="btn-send btn-s2" v-if="!isProcessing">Enviar</b-button>
					<b-button type="submit" disabled class="btn-send btn-s2" v-else>Procesando...</b-button>
				</div>
			</b-form>

		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
	data() {
		return {
			isProcessing: false,
			form: {
				telefono: '',
				nombres: '',
				apellido_paterno: '',
				apellido_materno: '',
				curp: '',
			}
		}
	},

	methods: {
		...mapActions(['portabilidadProcess']),
		makeToast(variant = null, msg, title) {
			this.$bvToast.toast(msg, {
				title: title,
				variant: variant,
				solid: true,
				toaster: 'b-toaster-top-right',
				appendToast: true
			})
		},

		async onSubmit(event) {
			event.preventDefault();
			if (!this.isProcessing) {
				this.isProcessing = true;
				let response = await this.portabilidadProcess(this.form)
				if (response) {
					this.$router.replace('/portabilidad/enviado');
				} else {
					this.isProcessing = false;
				}
			} else {
				console.log('API Ocupada');
			}
		},
	}
}
</script>
